import { render, staticRenderFns } from "./GoogleSignIn.vue?vue&type=template&id=570263fe&scoped=true&lang=pug"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js"
import style0 from "./GoogleSignIn.vue?vue&type=style&index=0&id=570263fe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570263fe",
  null
  
)

export default component.exports